module.exports = __webpack_public_path__ + "img/hic-cancer-male.8e29ac77.png";